export default __webpack_public_path__ + "static/media/16.8e19d66b.jpg";